export default __webpack_public_path__ + "static/media/FemaleFro.8057b3fc.svg";